import React from "react";

interface SummaryRowProps {
  label: string;
  value: React.ReactNode;
  highlight?: boolean;
}

const SummaryRow: React.FC<SummaryRowProps> = ({ label, value, highlight = false }) => (
  <div className="flex justify-between items-center py-1">
    <span className="text-gray-700">{label}</span>
    <span className={highlight ? "font-bold text-gray-900" : "text-gray-800"}>{value}</span>
  </div>
);

export default SummaryRow;
